<script setup lang="ts">
import type { TutorBillingRecordChip } from '../model/interfaces'

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'

import { useScrollCue } from '../model/scroll-cue.hook'

defineOptions({
  name: 'TutorBillingRecordChips',
})

defineProps<{
  chips: TutorBillingRecordChip[]
}>()

const { isScrollCue } = useScrollCue('chipsScroll')
</script>

<template>
  <div
    v-if="chips.length"
    :class="['tutor-billing-record-chips', { 'is-scroll-cue': isScrollCue }]"
  >
    <div
      ref="chipsScroll"
      class="tutor-billing-record-chips__scroll"
    >
      <div
        v-for="chip in chips"
        :key="chip.id"
        class="tutor-billing-record-chips__chip"
      >
        <AppText
          name="body2"
          color="slate-500"
        >
          {{ chip.id }}
        </AppText>
        <AppText
          v-if="chip.name"
          name="body2-medium"
          color="slate-900"
        >
          {{ chip.name }}
        </AppText>
      </div>
    </div>
    <span
      class="tutor-billing-record-chips__scroll-cue"
      aria-hidden="true"
    >
      <AppIcon :icon="faChevronDown" />
    </span>
  </div>
</template>

<style scoped lang="scss" src="./TutorBillingRecordChips.scss" />
